import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getAuth } from 'firebase/auth';
import { FIREBASE_AUTH_BASE_URLS } from './firebase-auth-base-urls.injection-token';

@Injectable()
export class FirebaseAuthInterceptor implements HttpInterceptor {
  constructor(@Inject(FIREBASE_AUTH_BASE_URLS) private baseUrls: string[]) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.baseUrls.some(baseUrl => req.url.startsWith(baseUrl))) {
      return next.handle(req);
    }

    return from(getAuth().currentUser!.getIdToken()).pipe(switchMap(token => next.handle(req.clone({ setHeaders: { Authorization: token } }))));
  }
}
